export const ProfileReviewSourcesAPI = () => {
	const { bugsnagClient } = window;
	const { api, apiVersionHeader } = window.Bark;

	const getReviewSources = (success, failure) => {
		api(
			`/seller/profile/review-source/`,
			null,
			(res) => {
				success(res);
			},
			(error) => {
				if (failure) {
					failure(error);
				} else {
					defaultFailCallback(error, `Failed to get profile review sources`);
				}
			},
			'GET',
			apiVersionHeader('v2'),
		);
	};

	const saveReviewSources = (data, success, failure) => {
		api(
			`/seller/profile/review-source/`,
			data,
			(res) => {
				success(res);
			},
			(error) => {
				if (failure) {
					failure(error);
				} else {
					defaultFailCallback(error, `Failed to save profile review sources`);
				}
			},
			'POST',
			apiVersionHeader('v2'),
		);
	};

	const updateReviewSource = (id, data, success, failure) => {
		api(
			`/seller/profile/review-source/${id}/`,
			data,
			(res) => {
				success(res);
			},
			(error) => {
				if (failure) {
					failure(error);
				} else {
					defaultFailCallback(error, `Failed to update profile review sources`);
				}
			},
			'PUT',
			apiVersionHeader('v2'),
		);
	};

	const defaultFailCallback = (error, message) => {
		bugsnagClient.notify(new Error(message), { metaData: error });
	};

	return {
		getReviewSources,
		saveReviewSources,
		updateReviewSource,
	};
};
